import React from "react";
import { firmarRRHH, firmarRL, firmaEmpleado } from '../recibos/RecibosService';
import { fabric } from "fabric";
import $ from "jquery";
import { EFIRMA, urlImageSign, firmaColaboradorApariencia } from "../../constans/constants";
import Resizer from "react-image-file-resizer";
import { Button, Container, Row, Col, Modal, Form } from "react-bootstrap";
import { inicializar, joinDetails, reload, get, create, remove, stringify } from "./AparienciaServicios"
import pdfdefault from '../../recibo-ejemplo.pdf'
import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist';
import 'pdfjs-dist/web/pdf_viewer.css';
import validarImagen from "../seguridad/ValidadorImagen";
import BreadCrumComponent from '../../components/componentes/BreadCrumComponent';

class AparienciaFirma extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tipoFirma: [],
      idTipoFirma: "",
      tipoAparienciaEmpresa: [],
      tipoAparienciaEmpleado: [],
      idTipoAparienciaEmpresa: 1,
      idTipoAparienciaEmpleado: 1,
      tipoDetalleEmpresa: [],
      idTipoDetalleEmpresa: "",
      tipoDetalleEmpleado: [],
      idTipoDetalleEmpleado: "",
      usuarioDetalle: [],
      idUsuarioDetalle: "",
      empresaDetalle: [],
      idEmpresaDetalle: "",
      fileImagenEmpresa: null,
      urlImagenEmpresa: urlImageSign,
      urlImagenEmpresaMostrar: urlImageSign,
      fileImagenEmpleado: null,
      urlImagenEmpleado: urlImageSign,
      urlImagenEmpleadoMostrar: urlImageSign,
      urlImageFirmaColaborador: firmaColaboradorApariencia,
      urlImageFirmaColaboradorMostrar: firmaColaboradorApariencia,
      firmasSeleccionadas: [],
      filePDF: null,
      urlPDF: null,
      containerHeight: 730,
      pageNumber: null,
      detalleTipoEmpresaSelect: [],
      stampEmpresa: { type: "png" },
      configEmpresa: {},
      configEmpleado: {},
      base64StampEmpresa: urlImageSign.replace(
        /^data:image\/(png|jpg|jpeg);base64,/,
        ""
      ),
      base64StampEmpleado: urlImageSign.replace(
        /^data:image\/(png|jpg|jpeg);base64,/,
        ""
      ),
      stampEmpleado: { type: "png" },
      signEmpresa: {
        id: 1,
        name: "Empresa",
        page: 1,
        color: "#0067a6",
        detailType: "",
        details: "",
        stamp: "",
        freeText: "",
        appearance: "",
      },
      signEmpleado: {
        id: 2,
        name: "Empleado",
        page: 1,
        color: "#30E156",
        detailType: "",
        details: "",
        stamp: "",
        freeText: "",
        appearance: "",
      },
      mensajeErrorAparienciaFirmaEmpresa: "",
      mensajeErrorAparienciaFirmaEmpleado: ""
    };
    //this.generarpdf(pdfReferencia)
  }
  componentDidMount() {
    const tipo = [
      { id: 1, nombre: "Empresa" },
      { id: 2, nombre: "Empleado" },
    ];

    const aparienciaEmpresa = [
      { id: 1, name: "Sin Apariencia" },
      { id: 2, name: "Apariencia Estandar" },
    ];
    const detallesEmpresa = [
      { id: 1, name: "Imagen" },
      { id: 2, name: "Texto" },
      { id: 3, name: "Texto-Imagen" },
    ];
    const aparienciaEmpleado = [
      { id: 1, name: "Sin Apariencia" },
      { id: 2, name: "Apariencia Estandar" },
    ];
    const detallesEmpleado = [
      { id: 1, name: "Imagen" },
      { id: 2, name: "Texto" },
      { id: 3, name: "Texto-Imagen" },
      { id: 4, name: "Firma Colaborador" }
    ];
    const usuarioDetalle = [
      { id: "${ci}", name: "CI", check: false },
      { id: "${nombre_apellidos}", name: "Nombre y Apellidos", check: false },
      /*       { id: "${lugar}", name: "Lugar", check: false }, */
    ];
    const empresaDetalle = [
      { id: "${ruc}", name: "RUC", check: false },
      { id: "${nombre_empresa}", name: "Nombre", check: false },
      /*       { id: "${ubicacion}", name: "Ubicación", check: false }, */
    ];
    this.setState({ tipoFirma: tipo });
    this.setState({ tipoAparienciaEmpresa: aparienciaEmpresa });
    this.setState({ tipoAparienciaEmpleado: aparienciaEmpleado });
    this.setState({ tipoDetalleEmpresa: detallesEmpresa });
    this.setState({ tipoDetalleEmpleado: detallesEmpleado });
    this.setState({ usuarioDetalle: usuarioDetalle });
    this.setState({ empresaDetalle: empresaDetalle });
    this.getBase64FromUrl(urlImageSign).then((result) => {
      this.setState({ base64StampEmpleado: result }); 
      this.setState({ base64StampEmpresa: result });
    });
    // myBase64 is the base64 string
    this.setState({ filePDF: pdfdefault })
    this.generarpdf(pdfdefault)
  }

  handleClose = () => {
    this.props.handleClose(false);
  };

  getBase64FromUrl = async (url) => {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result;
        resolve(base64data.replace(/^data:image\/(png|jpg|jpeg);base64,/, ""));
      }
    });
  }

  /*-----------------------PDF-----------------------------------*/
  onDocumentComplete = this.onDocumentComplete.bind(this);
  onDocumentComplete(pages) {
    this.setState({ page: 1, pages });
  }
  onChangeFilePDF = (e) => {
    const file = e.target.files[0];
    this.setState({ filePDF: file });
    
    const reader = new FileReader();
    reader.onloadend = () => {
      const dataUrl = reader.result;
      this.setState({ urlPDF: dataUrl });
      this.generarpdf(dataUrl);
    };
    reader.readAsDataURL(file);
  };

  generarpdf = (urlPD) => {
    // The workerSrc property shall be specified.
    //GlobalWorkerOptions.workerSrc = "/lib/build/pdf.worker.js";
    GlobalWorkerOptions.workerSrc =  `${window.location.origin}/mirecibo/visor/pdf.worker.js`;
    //GlobalWorkerOptions.workerSrc =  `${window.location.origin}/visor/pdf.worker.js`;
    var canvasContainer = document.querySelector(".canvas-container");
    if (canvasContainer != null) {
      var upperCanvas = document.querySelector(".upper-canvas");
      var canvasContainer = upperCanvas.parentNode;
      canvasContainer.removeChild(upperCanvas);
    }
    // Asynchronous download of PDF
    var loadingTask = getDocument(urlPD);
    loadingTask.promise.then(
      function (pdf) {
        // Fetch the first page
        var pageNumber = 1;
        pdf.getPage(pageNumber).then(function (page) {
          var scale = 1;
          var viewport = page.getViewport({ scale: scale });
          // Prepare canvas using PDF page dimensions
          var canvas = document.getElementById("the-canvas");
          var context = canvas.getContext("2d");
          canvas.height = viewport.height;
          canvas.width = viewport.width;
          // Render PDF page into canvas context
          var renderContext = {
            canvasContext: context,
            viewport: viewport,
          };
          var renderTask = page.render(renderContext);
          renderTask.promise.then(function () {
            inicializar(canvas);
          });
        });
      },
      function (reason) {
        console.error(reason);
      }
    );
  };
  /*---------------Fin PDF---------------------*/

  /*---------------Imagen----------------------*/
  getBase64 = (file) => {
    return new Promise((resolve) => {
      let fileInfo;
      let baseURL = "";
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  /*------------------Fin Imagen-----------------*/

  /*---------------Empresa---------------------*/
  handeCheckEmpresa = (e) => {
    var detallesTextAux = [];
    var datosActualizar = this.state.empresaDetalle;
    datosActualizar.forEach((detalle) => {
      if (e.target.value == detalle.id) {
        detalle.check = e.target.checked;
      }
      if (detalle.check) {
        detallesTextAux.push(detalle);
      }
    });
    this.actualizarCanvasEmpresa(detallesTextAux);
    this.setState({ empresaDetalle: datosActualizar });
  };

  actualizarCanvasEmpresa = (text) => {
    var urlImage = undefined;
    if (
      this.state.idTipoDetalleEmpresa == 1 ||
      this.state.idTipoDetalleEmpresa == 3
    ) {
      urlImage = this.state.urlImagenEmpresa;
    }
    var config = {
      id: 1,
      borderColor: "#0067a6",
      text: joinDetails("", text),
      stampUrl: urlImage,
    };
    this.setState({ configEmpresa: config })
    reload(config);
    var typeDetails = this.state.tipoDetalleEmpresa.find(
      (tipo) => tipo.id == this.state.idTipoDetalleEmpresa
    );
    var details = this.state.empresaDetalle.filter(
      (detalle) => detalle.check == true
    );
    this.setState({
      signEmpresa: {
        id: 1,
        page: 1,
        name: "Empresa",
        color: "#0067a6",
        detailType: typeDetails,
        details: details,
        stamp: urlImage,
        appearance: get(1),
      },
    });
  };

  handleUploadLogoEmpresa = (event) => {
    event.preventDefault();
    validarImagen(event.target.files[0]).then((resultadoAnalisis) => {
      if (resultadoAnalisis.isValid) {
        this.setState({ fileImagenEmpresa: event.target.files[0] });
        
        // Convertir a data URL en lugar de usar blob URL
        const reader = new FileReader();
        reader.onload = (e) => {
          const dataUrl = e.target.result;
          this.setState({
            urlImagenEmpresa: dataUrl,
            stampEmpresa: event.target.files[0],
          });
          this.asignarBase64Empresa(event.target.files[0]);
          
          try {
            Resizer.imageFileResizer(
              event.target.files[0],
              250,
              200,
              "PNG",
              0,
              0,
              (uri) => {
                // Convertir la imagen redimensionada a data URL
                const readerResized = new FileReader();
                readerResized.onload = (e) => {
                  this.setState({
                    urlImagenEmpresaMostrar: e.target.result,
                  });
                };
                readerResized.readAsDataURL(uri);
              },
              "file"
            );
          } catch (error) {
            this.setState({ mensajeErrorAparienciaFirmaEmpresa: "Ocurrio un error al cargar la imagen" })
          }
          
          // Pasar la data URL al canvas
          this.createCanvasImageEmpresa(dataUrl);
          this.setState({mensajeErrorAparienciaFirmaEmpresa: ""})
        };
        reader.readAsDataURL(event.target.files[0]);
      } else {
        this.setState({ mensajeErrorAparienciaFirmaEmpresa: resultadoAnalisis.error })
      }
    })
  };

  createCanvasImageEmpresa(urlImageSign) {
    var config = {
      id: 1,
      stampUrl: urlImageSign,
      borderColor: "#0067a6",
    };
    this.setState({ configEmpresa: config })
    var typeDetails = this.state.tipoDetalleEmpresa.find(
      (tipo) => tipo.id == this.state.idTipoDetalleEmpresa
    );
    var details = this.state.empresaDetalle.filter(
      (detalle) => detalle.check == true
    );

    create(config);
    this.setState({
      signEmpresa: {
        id: 1,
        page: 1,
        name: "Empresa",
        color: "#0067a6",
        detailType: typeDetails,
        details: details,
        stamp: urlImageSign,
        appearance: get(1),
      },
    });
  }

  createCanvasTextEmpresa(text) {
    var config = {
      id: 1,
      stampUrl: undefined,
      borderColor: "#0067a6",
      text: joinDetails("", text),
    };
    this.setState({ configEmpresa: config })
    var typeDetails = this.state.tipoDetalleEmpresa.find(
      (tipo) => tipo.id == this.state.idTipoDetalleEmpresa
    );
    var details = this.state.empresaDetalle.filter(
      (detalle) => detalle.check == true
    );
    create(config);
    this.setState({
      signEmpresa: {
        id: 1,
        page: 1,
        name: "Empresa",
        color: "#0067a6",
        detailType: typeDetails,
        details: details,
        stamp: undefined,
        appearance: get(1),
      },
    });
  }

  clearCheckEmpresa = () => {
    var datosActualizar = this.state.empresaDetalle;
    datosActualizar.forEach((detalle) => {
      detalle.check = false;
    });
    this.setState({ empresaDetalle: datosActualizar });
  };

  asignarBase64Empresa = (file) => {
    this.getBase64(file)
      .then((result) => {
        file["base64"] = result;
        this.setState({
          base64StampEmpresa: result,
        });
      })
      .catch((err) => {
      });
  };

  /*--------------------Fin Empresa------------------ */

  /*--------------------Colaborador-----------------*/
  handeCheckEmpleado = (e) => {
    var detallesTextAux = [];
    var datosActualizar = this.state.usuarioDetalle;
    datosActualizar.forEach((detalle) => {
      if (e.target.value == detalle.id) {
        detalle.check = e.target.checked;
      }
      if (detalle.check) {
        detallesTextAux.push(detalle);
      }
    });
    this.actualizarCanvasEmpleado(detallesTextAux);
    this.setState({ usuarioDetalle: datosActualizar });
  };

  actualizarCanvasEmpleado = (text) => {
    var urlImage = undefined;
    if (
      this.state.idTipoDetalleEmpleado == 1 ||
      this.state.idTipoDetalleEmpleado == 3
    ) {
      urlImage = this.state.urlImagenEmpleado;
    }
    if (this.state.idTipoDetalleEmpleado == 4) {
      urlImage = this.state.urlImageFirmaColaborador
    }
    var config = {
      id: 2,
      borderColor: "#30E156",
      text: joinDetails("", text),
      stampUrl: urlImage,
    };
    this.setState({ configEmpleado: config })
    reload(config);
    var typeDetails = this.state.tipoDetalleEmpleado.find(
      (tipo) => tipo.id == this.state.idTipoDetalleEmpleado
    );
    var details = this.state.usuarioDetalle.filter(
      (detalle) => detalle.check == true
    );
    this.setState({
      signEmpleado: {
        id: 2,
        page: 1,
        name: "Empleado",
        color: "#30E156",
        detailType: typeDetails,
        details: details,
        stamp: urlImage,
        appearance: get(2),
      },
    });
  };

  handleUploadLogoEmpleado = (event) => {
    event.preventDefault();
    validarImagen(event.target.files[0]).then((resultadoAnalisis) => {
      if (resultadoAnalisis.isValid) {
        this.setState({ fileImagenEmpleado: event.target.files[0] });
        
        // Convertir a data URL en lugar de usar blob URL
        const reader = new FileReader();
        reader.onload = (e) => {
          const dataUrl = e.target.result;
          this.setState({
            urlImagenEmpleado: dataUrl,
            stampEmpleado: event.target.files[0],
          });
          this.asignarBase64Empleado(event.target.files[0]);
          
          try {
            Resizer.imageFileResizer(
              event.target.files[0],
              250,
              200,
              "PNG",
              0,
              0,
              (uri) => {
                // Convertir la imagen redimensionada a data URL
                const readerResized = new FileReader();
                readerResized.onload = (e) => {
                  this.setState({
                    urlImagenEmpleadoMostrar: e.target.result,
                  });
                };
                readerResized.readAsDataURL(uri);
              },
              "file"
            );
          } catch (error) {
            this.setState({ mensajeErrorAparienciaFirmaEmpleado: "Ocurrio un error al cargar la imagen" })
          }
          
          // Pasar la data URL al canvas
          this.createCanvasImageEmpleado(dataUrl);
          this.setState({mensajeErrorAparienciaFirmaEmpleado: ""})
        };
        reader.readAsDataURL(event.target.files[0]);
      } else {
        this.setState({ mensajeErrorAparienciaFirmaEmpleado: resultadoAnalisis.error })
      }
    })
  };

  createCanvasImageEmpleado(urlImageSign) {
    var config = {
      id: 2,
      stampUrl: urlImageSign,
      borderColor: "#30E156",
    };
    this.setState({ configEmpleado: config })
    var typeDetails = this.state.tipoDetalleEmpleado.find(
      (tipo) => tipo.id == this.state.idTipoDetalleEmpleado
    );
    var details = this.state.usuarioDetalle.filter(
      (detalle) => detalle.check == true
    );

    create(config);
    this.setState({
      signEmpleado: {
        id: 2,
        page: 1,
        name: "Empleado",
        color: "#30E156",
        detailType: typeDetails,
        details: details,
        stamp: urlImageSign,
        appearance: get(2),
      },
    });
  }

  createCanvasTextEmpleado(text) {
    var config = {
      id: 2,
      stampUrl: undefined,
      borderColor: "#30E156",
      text: joinDetails("", text),
    };
    this.setState({ configEmpleado: config })
    var typeDetails = this.state.tipoDetalleEmpleado.find(
      (tipo) => tipo.id == this.state.idTipoDetalleEmpleado
    );
    var details = this.state.usuarioDetalle.filter(
      (detalle) => detalle.check == true
    );
    create(config);
    this.setState({
      signEmpleado: {
        id: 2,
        page: 1,
        name: "Empleado",
        color: "#30E156",
        detailType: typeDetails,
        details: details,
        stamp: undefined,
        appearance: get(2),
      },
    });
  }

  clearCheckEmpleado = () => {
    var datosActualizar = this.state.usuarioDetalle;
    datosActualizar.forEach((detalle) => {
      detalle.check = false;
    });
    this.setState({ usuarioDetalle: datosActualizar });
  };

  asignarBase64Empleado = (file) => {
    this.getBase64(file)
      .then((result) => {
        file["base64"] = result;
        this.setState({
          base64StampEmpleado: result,
        });
      })
      .catch((err) => {
      });
  };

  /*-------------------Fin Colaborador----------------------------*/

  handleInput = (e) => {
    var name = e.target.name;
    var val = e.target.value;
    this.setState({
      [name]: val,
    });
    if (
      (name == "idTipoDetalleEmpresa" && val == 1) ||
      (name == "idTipoDetalleEmpresa" && val == 3)
    ) {
      this.createCanvasImageEmpresa(this.state.urlImagenEmpresa);
    }
    if (name == "idTipoDetalleEmpresa" && val == 2) {
      this.createCanvasTextEmpresa([
        {
          id: "${mirecibo}",
          name: "mirecibo",
          check: true,
        },
      ]);
    }
    if (name == "idTipoDetalleEmpleado" && val == 2) {
      this.createCanvasTextEmpleado([
        {
          id: "${mirecibo}",
          name: "mirecibo",
          check: true,
        },
      ]);
    }
    if (
      (name == "idTipoDetalleEmpleado" && val == 1) ||
      (name == "idTipoDetalleEmpleado" && val == 3)
    ) {
      this.createCanvasImageEmpleado(this.state.urlImagenEmpleado);
    }
    if (
      (name == "idTipoDetalleEmpleado" && val == 4)) {
      this.createCanvasImageEmpleado(this.state.urlImageFirmaColaborador);
    }
    if (name == "idTipoAparienciaEmpresa" && val == 1) {
      remove(1);
      this.clearCheckEmpresa();
      this.setState({ idTipoDetalleEmpresa: "" });
    }
    if (name == "idTipoAparienciaEmpleado" && val == 1) {
      remove(2);
      this.clearCheckEmpleado();
      this.setState({ idTipoDetalleEmpleado: "" });
    }
  };
  guardar = async () => {
    await this.reloadCanvas
    if (this.state.idTipoDetalleEmpresa == 2) {
      this.setState((prevState) => ({
        ...prevState,
        signEmpresa: {
          ...prevState.signEmpresa,
          appearance: get(1),
        },
      }));
    }
    if (this.state.idTipoDetalleEmpleado == 2) {
      this.setState((prevState) => ({
        ...prevState,
        signEmpleado: {
          ...prevState.signEmpleado,
          appearance: get(2),
        },
      }));
    }
    var typeDetailEmpresa = this.state.tipoDetalleEmpresa.find(
      (tipo) => tipo.id == this.state.idTipoDetalleEmpresa
    );
    var jsonEmpresa = stringify(
      typeDetailEmpresa,
      this.state.signEmpresa,
      this.state.stampEmpresa,
      this.state.base64StampEmpresa
    );
    var typeDetailEmpleado = this.state.tipoDetalleEmpleado.find(
      (tipo) => tipo.id == this.state.idTipoDetalleEmpleado
    );

    var jsonEmpleado = stringify(
      typeDetailEmpleado,
      this.state.signEmpleado,
      this.state.stampEmpleado,
      this.state.base64StampEmpleado
    );
    this.props.firmaEmpresa(jsonEmpresa);
    this.props.firmaEmpleado(jsonEmpleado);
    this.handleClose();
  };

  reloadCanvas() {
    reload(this.state.configEmpresa)
    reload(this.state.configEmpleado)
  }
  verificarPdfReferencia = () => {
    if (
      (!this.state.filePDF && this.state.idTipoAparienciaEmpresa == 2) ||
      (!this.state.filePDF && this.state.idTipoAparienciaEmpleado == 2)
    ) {
      return true;
    } else {
      return false;
    }
  };

  render() {
    const containerStyle = {
      display: 'flex',
      flexDirection: 'column',
      height: '100%'
    };

    const canvasStyle = {
      flex: 1,
      width: '100%',
      height: '100%'
    };
    const backUrl = this.props.backUrl || '/configuracion/tipo-documento';
    const breadcrumbLabel = this.props.breadcrumbLabel || 'Tipos de documentos';
    return (
      <div>
        <div className="template-base">
          <header className="component-header">
            <div className="page-container">
              <BreadCrumComponent
                backUrl={backUrl}
                breadcrumbs={
                  [
                    { label: breadcrumbLabel, path: backUrl },
                    { label: 'Editar apariencia de firma', path: '' }
                  ]
                }
              />
              <div className="head-area">
                <div className="caption-area">
                  <h1 className="page-title"> Editar Apariencia de Firma </h1>
                  <p className="page-description"> Configure la apariencia visual de las firmas dentro del documento </p>
                </div>
                <div className="head-actions">
                  <button onClick={this.guardar} className="btn-medium btn-primary"> GUARDAR </button>
                </div>
              </div>
            </div>
          </header>
          <div className="wrapperContent">
            <div className="component-configurar-apariencia">
              <div className="page-container">
                <div className="card">
                  <div className="grid-30-70">
                    <div className="config-area">

                      <h3 className="form-subtitle"> Seleccione archivo de Referencia </h3>
                      <div className="form-group">
                        <input className="form-input inputFile" type="file" onChange={this.onChangeFilePDF} accept=".pdf" />
                      </div>
                      <hr />
                      {
                        this.props.isFirmaEmpresa &&
                        <div>
                          <h3 className="form-subtitle"> Firma de Empresa </h3>
                          <div className="form-group">
                            <select className="form-select" name="idTipoAparienciaEmpresa" id="idTipoAparienciaEmpresa" onChange={this.handleInput} value={this.state.idTipoAparienciaEmpresa}>
                              <option value=""> </option>
                              {this.state.tipoAparienciaEmpresa.map((elemento) => (
                                <option key={elemento.id} value={elemento.id}>
                                  {elemento.name}
                                </option>
                              ))}
                            </select>
                            <label htmlFor="idTipoAparienciaEmpresa" className="form-label"> Tipo de Apariencia </label>
                          </div>
                          {this.state.idTipoAparienciaEmpresa == 2 &&
                            this.state.filePDF ? (<div className="form-group">
                              <select className="form-select"
                                name="idTipoDetalleEmpresa"
                                id="idTipoDetalleEmpresa"
                                onChange={this.handleInput}
                                value={this.state.idTipoDetalleEmpresa}>
                                <option key="" value=""> </option>
                                {this.state.tipoDetalleEmpresa.map((elemento) => (
                                  <option key={elemento.id} value={elemento.id}>
                                    {elemento.name}
                                  </option>
                                ))}
                              </select>
                              <label htmlFor="idTipoDetalleEmpresa" className="form-label"> Detalles de apariencia de firma </label>
                            </div>) : null}
                          {(this.state.idTipoDetalleEmpresa == 2 &&
                            this.state.idTipoAparienciaEmpresa == 2) ||
                            (this.state.idTipoDetalleEmpresa == 3 &&
                              this.state.idTipoAparienciaEmpresa == 2) ? (
                            <div className="inline-group">
                              {this.state.empresaDetalle.map((elemento) => (
                                <div className="form-group">
                                  <input key={elemento.id} type="checkbox" className="form-check" onClick={this.handeCheckEmpresa} name="checkEmpresa" value={elemento.id} id="checkEmpresa" />
                                  <label htmlFor="checkEmpresa" className="check-label"> {elemento.name} </label>
                                </div>
                              ))}
                            </div>
                          ) : null}
                          {this.state.idTipoAparienciaEmpresa == 2 ? (
                            <div className="form-group">
                              <input className="form-input inputFile" type="file" id="formFile" accept=".png" onChange={this.handleUploadLogoEmpresa} />
                            </div>) : null}
                        </div>
                      }
                      <hr />
                      {
                        this.props.isFirmaColaborador &&
                        <div>
                          <h3 className="form-subtitle"> Firma del {this.props.labelColaborador || "colaborador"} </h3>
                          <div className="form-group">
                            <select className="form-select" name="idTipoAparienciaEmpleado" id="idTipoAparienciaEmpleado" onChange={this.handleInput} value={this.state.idTipoAparienciaEmpleado}>
                              <option value=""> </option>
                              {this.state.tipoAparienciaEmpleado.map((elemento) => (
                                <option key={elemento.id} value={elemento.id}>
                                  {elemento.name}
                                </option>
                              ))}
                            </select>
                            <label htmlFor="idTipoAparienciaEmpleado" className="form-label"> Tipo de Apariencia </label>
                          </div>
                          {this.state.idTipoAparienciaEmpleado == 2 &&
                            this.state.filePDF ? (<div className="form-group">
                              <select className="form-select"
                                name="idTipoDetalleEmpleado"
                                id="idTipoDetalleEmpleado"
                                onChange={this.handleInput}
                                value={this.state.idTipoDetalleEmpleado}>
                                <option key="" value=""> </option>
                                {this.state.tipoDetalleEmpleado.map((elemento) => (
                                  <option key={elemento.id} value={elemento.id}>
                                    {elemento.name}
                                  </option>
                                ))}
                              </select>
                              <label htmlFor="idTipoDetalleEmpresa" className="form-label"> Detalles de apariencia de firma </label>
                            </div>) : null}
                          {(this.state.idTipoDetalleEmpleado == 2 &&
                            this.state.idTipoAparienciaEmpleado == 2) ||
                            (this.state.idTipoDetalleEmpleado == 3 &&
                              this.state.idTipoAparienciaEmpleado == 2) ? (
                            <div className="inline-group">
                              {this.state.usuarioDetalle.map((elemento) => (
                                <div className="form-group">
                                  <input key={elemento.id} type="checkbox" className="form-check" onClick={this.handeCheckEmpleado} name="checkEmpleado" value={elemento.id} id="checkEmpleado" />
                                  <label htmlFor="checkEmpleado" className="check-label"> {elemento.name} </label>
                                </div>
                              ))}
                            </div>
                          ) : null}
                          {this.state.idTipoAparienciaEmpleado == 2 ? (
                            <div className="form-group">
                              <input className="form-input inputFile" type="file" id="formFile" accept=".png" onChange={this.handleUploadLogoEmpleado} />
                            </div>) : null}
                        </div>
                      }
                    </div>
                    <div>
                      <div className="canvas-container">
                        <canvas
                          id="the-canvas"
                        ></canvas>
                        <canvas className="upper-canvas"></canvas>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    );
  }
}

export default AparienciaFirma;
